module.exports = "fragment Price on Price {\n  asString\n  currency\n  amount\n}\n"